var React = require('react');

function TemplateLibrary (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M385.9,53V0h-86.1V53l-99.6,0V0h-86.1v53L0,53v138.8h500V53L385.9,53z M325.2,26.9l34.6,0V53l-34.6,0V26.9z M139.5,26.9\n\tl34.6,0V53l-34.6,0V26.9z M473.2,165H26.8V80.6l446.4,0V165z M385.9,218.2h-86.1v52.9l-99.6,0v-52.9h-86.1v53L0,271.2V500h500V271.2\n\tl-114.1,0V218.2z M325.2,245.1h34.6v26.1l-34.6,0V245.1z M139.5,245.1h34.6v26.1l-34.6,0V245.1z M473.2,473.1H26.8v-73.8l446.4,0\n\tV473.1z M473.2,298.9v72.9l-446.4,0v-73L473.2,298.9z"}));
}

TemplateLibrary.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 500 500","style":{"enableBackground":"new 0 0 500 500"},"xmlSpace":"preserve"};

module.exports = TemplateLibrary;

TemplateLibrary.default = TemplateLibrary;
